var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPricing = function SvgPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m3.127 11.475 3.398 3.398a3.585 3.585 0 0 0 5.063 0l3.292-3.293a3.585 3.585 0 0 0 0-5.063l-3.405-3.39a3.563 3.563 0 0 0-2.7-1.042l-3.75.18a2.898 2.898 0 0 0-2.768 2.752l-.18 3.75a3.603 3.603 0 0 0 1.05 2.708Z",
    fill: "#EF940F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 9.285a2.16 2.16 0 1 0 0-4.32 2.16 2.16 0 0 0 0 4.32Z",
    fill: "#EF940F"
  })));
};
export default SvgPricing;